import { FC, ReactNode } from 'react';
import cls from './modal-actions.module.scss';

interface ModalActionsProps {
  children: ReactNode;
  className?: string;
}

export const ModalActions: FC<ModalActionsProps> = ({
  children,
  className = '',
}) => <div className={`${cls.modalActions} ${className}`}>{children}</div>;
